import React, { useState } from 'react'
import "./HomeProgram.css"
import ServicesCarasoul from '../ServicesCarasoul/ServicesCarasoul'
import { useNavigate } from 'react-router-dom'
import Modal from '../Modal/Modal';
import CalendlyFormModal from '../CalendlyFormEmbed/CalendlyFormEmbed';

function HomeProgram({
    mainCardHeading="",
    blueSubHeading="",
    mainCardPara="",
    btnText="",
    btnRef="",
    serviceData,
    mainCardImg,
    showList=true,
    leftBottomBorderRadius=false,
    rightBottomBorderRadius=false,
    backgroundPlain=false,
    switchRow=false,
    noTopMargin=false,
    paddingRight=false,
    paddingTopContent=false,
    fontBold=false,
    imagebottom=false,
    videoSrc,
    btnCalnedly=false,
    calendlyType=0
}) {
  const [modal, setModal] = useState(false);
  const [openCalendly, setOpenCalendly] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = (e) => {
      setModal((prev)=>{
          return !prev
      });
  };

  const paragraphs = mainCardPara.split('\n').map((paragraph, index) => <p key={index} className={`body-paragraph color-light my-1 mb-3 `}>{paragraph}</p>);
    const navigate = useNavigate()
  return (
    
    <div className={`HomeProgram-container standard-padding-space ${backgroundPlain && "removeAfterEffect"}`}
      style={{background:`${backgroundPlain?"transparent":"auto"}`}}
    >
        {
            openCalendly &&
            <CalendlyFormModal intialOpenState={openCalendly} setOpenState={setOpenCalendly} calendlyType={calendlyType}/>
        }
      {modal ? <Modal status={modal} closeModal={toggleModal} videoSrc={videoSrc} /> : <></>}
      <div className="container">
        <div className={`main-card p-5 ${!noTopMargin ? "pt-1":"pt-lg-0"} pb-lg-0 pb-4 ${switchRow?"px-lg-2":"pe-lg-2"} `}>
          <div className={`row ${!noTopMargin && "my-5"} ${paddingRight && "pe-lg-5"} gy-lg-0 gy-4 mb-lg-0 align-items-center ${switchRow?"flex-row-reverse":"flex-row"}`}>
            <div className={`col-lg-6 text-lg-start text-center pb-lg-4 pb-0 ${switchRow?"ps-lg-5":""} ${paddingTopContent && "pt-lg-2"}`}>
              <h3
                className="main-heading color-light"
                style={fontBold?
                  {

                  fontSize: "34px",
                  lineHeight: "1.5",
                  fontWeight: "800",
                }
                  :
                  {

                  fontSize: "28px",
                  lineHeight: "1.5",
                  fontWeight: "600",
                }}
              >
                {mainCardHeading}
              </h3>
              {blueSubHeading && <p className="body-paragraph color-blue pt-2">{blueSubHeading}</p>}
              <div className="py-4 pe-lg-4">{paragraphs}</div>
              <button
                className="genral-btn"
                onClick={() => {
                  if(btnCalnedly)
                  {
                    setOpenCalendly(true)
                  }
                  else{
                    navigate(btnRef);
                  }
                }}
              >
                {btnText}
              </button>
            </div>

            <div className={`col-lg-6 ${switchRow?"ps-0 me-auto":"pe-0"} ${imagebottom&& "mt-lg-auto"}`}>
              <img
                src={mainCardImg}
                alt="thumbnail"
                onClick={()=>{if(videoSrc)setModal(true)}}
                className={`img-fluid thumbnail ${leftBottomBorderRadius && "leftBottomBorderRadiusZero"} ${rightBottomBorderRadius && "rightBottomBorderRadiusZero"}`}
              />
            </div>
          </div>
        </div>
      </div>
      {showList && (
        <div style={{ overflowX: "hidden" }}>
          <div className="mt-5 slider-container">
            <ServicesCarasoul serviceData={serviceData} />
          </div>
        </div>
      )}
    </div>
  );
}

export default HomeProgram